import React from 'react'
import styled from 'styled-components'

const RadioButtonGroup = ({ title, name, list, onChange, selected }) => {
  return (
    <StyledWrapper>
      <label>{title}</label>
      <div className="radio__btns">
        {list.map((e, i) => {
          const inputId = `${name}-${i}`
          return (
            <StyledRadioButton key={i}>
              <div className="radio">
                <input
                  id={inputId}
                  className="radio__input"
                  type="radio"
                  name={name}
                  value={e.value}
                  checked={selected === e.value}
                  onChange={(e) => onChange(e.target.value)}
                />
                <label htmlFor={inputId} className="small-subTitle">
                  {e.label}
                </label>
              </div>
            </StyledRadioButton>
          )
        })}
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  label {
    font-size: 0.875rem;
    font-weight: 300;
    color: #0e1324;
    letter-spacing: 3%;
    line-height: 1.7;
  }

  .radio__btns {
    display: flex;
    align-items: center;
    margin-top: 1rem;
  }
`

const StyledRadioButton = styled.div`
  display: flex;
  align-items: center;

  .radio {
    display: flex;
    align-items: center;
    margin-right: 2rem;

    .radio__input {
      accent-color: #ff7b9b;
      width: 19px;
      height: 19px;
    }

    label {
      margin-left: 10px;
    }
  }
`

export default RadioButtonGroup
